export default "__VITE_ASSET__DSMeg9Hv__"